export const regionalOverview = {
  defaultYear: "Ano padrão",
  selectYear: "Selecione o ano para comparar",
  selectedYear: "Ano selecionado",
  note: "*Nota: Os dados apresentados nestes gráficos representam informações que foram aprovadas pelo governo.",
};
